const { errors: ERRORS } = require('./constants')

class ArtemisError extends Error {
  constructor({ error = {}, details }) {
    super(error.message)

    const { code, message } = error
    this.code = code
    this.message = message
    this.details = details
    this.isArtemisError = true
  }
}

class AuthorizationError extends ArtemisError {
  constructor(details) {
    super({ error: ERRORS.AUTHORIZATION_ERROR, details })
  }
}

class CardTokenizationError extends ArtemisError {
  constructor(error) {
    super({ error, details: error.details })
    this.statusCode = error.statusCode
  }
}

class ForbiddenError extends ArtemisError {
  constructor(details) {
    super({ error: ERRORS.FORBIDDEN_ERROR, details })
  }
}

class InternalServerError extends ArtemisError {
  constructor(details) {
    super({ error: ERRORS.INTERNAL_SERVER_ERROR, details })
  }
}

class NotFoundError extends ArtemisError {
  constructor(details) {
    super({ error: ERRORS.NOT_FOUND_ERROR, details })
  }
}

class ValidationError extends ArtemisError {
  constructor(details, argumentValue) {
    super({ error: ERRORS.VALIDATION_ERROR, details })
    this.argumentValue = argumentValue
  }
}

class NotCapturedError extends ArtemisError {
  constructor(details) {
    super({ error: ERRORS.NOT_CAPTURED, details })
  }
}

class CreatePaymentMethodError extends ArtemisError {
  constructor(details) {
    super({ error: ERRORS.CREATE_PAYMENT_METHOD_ERROR, details })
  }
}

module.exports = {
  AuthorizationError,
  CardTokenizationError,
  ForbiddenError,
  InternalServerError,
  NotCapturedError,
  CreatePaymentMethodError,
  NotFoundError,
  ValidationError,
}
